import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Subject } from 'rxjs/Subject';

import { MessageService } from 'primeng/components/common/messageservice';

import { environment } from '../../../environments/environment';
import { BaseService } from '../base/util/base.service';
import { buscarSituacoesETiposAnexo, buscarSituacoesETiposAnexoAutorizacaoVinculacao } from '../base/util/url-util';
import { SituacoesETiposAnexoVO } from '../base/vo/situacoes-e-tipos-anexo';


@Injectable()
export class AnexarImagensService extends BaseService {

  public anexosChangeEvent = new Subject<boolean>();

  constructor(
    private httpClient: HttpClient,
    public messageService: MessageService
  ) {
    super(httpClient, messageService);
  }

  public buscarSituacoesETiposAnexo() {
    return this.get(buscarSituacoesETiposAnexo());
  }

  public buscarSituacoesETiposAnexoAutorizacaoVinculacao(situacoesETiposAnexoVO: SituacoesETiposAnexoVO) {
    return this.http
      .post<any>(buscarSituacoesETiposAnexoAutorizacaoVinculacao(), situacoesETiposAnexoVO);

  }

  public urlDocuware() {
    const url = `${environment.urlApi}gto/url-docuware`;

    return this.get(url);
  }

  emitAnexosChangeEvent(val) {
    this.anexosChangeEvent.next(val);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/anexar-imagens/anexar-imagens.service.ts